import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LookupService } from '../../../../services/lookups/lookup.service';
import { LookupAdminService } from '../../../../services/lookups/lookupadmin.service';
import {Location} from '../../../../models/user.model';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-post-detail',
  templateUrl: './post-detail.component.html',
  styleUrls: ['./post-detail.component.css']
})
export class PostDetailComponent implements OnInit {
  countries: Location[] = [];
  @Output() showHidePostDetailDlg = new EventEmitter<boolean>();
  @Output() refreshDataSource=new EventEmitter<boolean>();
  postDetailForm: FormGroup;

  constructor(private fb: FormBuilder, 
              private lookupService: LookupService,
              private lookupAdminService:LookupAdminService,
              private notifier: NotifierService) {}

  ngOnInit() {
    this.postDetailForm = this.fb.group({
      Id: [''],
      postName: ['', [Validators.required, Validators.pattern(/^[ A-Za-z0-9_'-]*$/)]],
      country: ['', Validators.required],
      isActive:['',Validators.required],
      //lastUpdatedBy:[''],
      lastUpdatedDateTime:['']
    });
  }

  showPostDetailDialog(location: Location) {
    // console.log(id);
    //this.lookupService.getRootLocations(this.authUser._user.userType.typeName).subscribe((data: Location[]) => {
      this.lookupService.getAllCountries$().subscribe((data: Location[]) => {
      this.countries = data;
      this.countries.sort(
        (a, b): number => {
          if (a.locationName < b.locationName) return -1;
          if (a.locationName > b.locationName) return 1;
          return 0;
        }
      );
    });
    
    if(location!=null)
    {
      //console.log(location);
      this.postDetailForm.patchValue({
          Id:location.id,
          postName:location.locationName,
          country:location.parentLocation,
          isActive :String(location.isActive),
          lastUpdatedDateTime : new Date(location.lastUpdatedDateTime).toLocaleString()
      });
    }
    else
    {
      this.postDetailForm.reset();
    }

  }

  onCancelPostDetail()
  {
    this.postDetailForm.reset();
    this.showHidePostDetailDlg.emit(false);
    this.refreshDataSource.emit(true);
  }
  onSavePostDetail()
  { 
       if(this.postDetailForm.valid)
       {
         let post= Object.assign(new Location(),this.postDetailForm.value);
         post.parentId = post.country.id;
         post.locationName =post.postName;
         this.lookupAdminService.savePost(post).subscribe((resp)=>{
           if(resp.ok)
           {
            this.notifier.notify('success', 'Post saved successfully');
           }

       },error=>{
          this.notifier.notify('error', 'Failed to save Post, contact tech support');
          });
        
       // this.refreshDataSource.emit(true);

       }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/lookup-management/post/post-detail/post-detail.component.ts